import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from 'api/api';
import { ReleaseRef } from 'hooks/data/versions/types';
import { useResolvedRelease } from 'hooks/useVersionInfo';

import { FetchDatasetParams } from '../types';

import { ExchangesResponse } from './types';

const fetchExchanges = async (params: FetchDatasetParams) => {
  const { data } = await api.get(`/spold/exchanges`, { params });

  return data;
};

/** `release` targets a specific release instead of the route's. See useDataset. */
const useExchanges = (id?: string, release?: ReleaseRef) => {
  const { version, system_model } = useResolvedRelease(release);
  return useQuery<ExchangesResponse, AxiosError>({
    queryKey: ['exchanges', id, version, system_model],
    queryFn: () => fetchExchanges({ dataset_id: id as string, version, system_model }),
    enabled: !!id,
  });
};

export default useExchanges;
